<template>
  
  <div :class="pageCss">

    <div class="wrapper__inner--narrow">
      <section>
        <div><img :src="content.image"></div>
        <div>
          <span>
            <strong>{{ content.author }}</strong><br>{{ content.position }}           
          </span>
        </div>
      </section>
    </div>
  </div>

</template>

<script>

  export default {
    name: 'SectionAuthor',
    props: {
      content: {
        type: Object,
        required: true,
        default: () => {}
      }
    },
    computed: {

      pageCss() {
        return `content content__${this.content.type}`;
      },

    }
  };
</script>